import { createContext, useContext, useState } from 'react';

type MenuContextType = {
  activeMenuKey: string | null;
  setActiveMenuKey: (key: string | null) => void;
  openMenu?: boolean;
  setOpenMenu?: (open: boolean) => void;
};

const MenuContext = createContext<MenuContextType | null>(null);

export function MenuProvider({ children }: { children: React.ReactNode }) {
  const [activeMenuKey, setActiveMenuKey] = useState<string | null>(
    sessionStorage.getItem('activeMenu') || null,
  );
  const [openMenu, setOpenMenu] = useState<boolean>(true);

  const setAndStoreKey = (key: string | null) => {
    sessionStorage.setItem('activeMenu', key || '');
    setActiveMenuKey(key);
  };

  return (
    <MenuContext.Provider
      value={{
        activeMenuKey,
        setActiveMenuKey: setAndStoreKey,
        openMenu,
        setOpenMenu,
      }}
    >
      {children}
    </MenuContext.Provider>
  );
}

export const useMenuContext = () => {
  const context = useContext(MenuContext);
  if (!context) {
    throw new Error('useMenuContext must be used within a MenuProvider');
  }
  return context;
};
